const PrepareConsoleTypes = {
    PrepareConsole_ACTION_START:"PrepareConsole_ACTION_START",
    PrepareConsole_FETCH_DATA:"PrepareConsole_FETCH_DATA",
    PrepareConsole_FETCH_DATA_FAILED:"PrepareConsole_FETCH_DATA_FAILED",
    PrepareConsole_ADD_DATA:"PrepareConsole_ADD_DATA",
    PrepareConsole_SOCKET_UPDATE:"PrepareConsole_SOCKET_UPDATE",
}

const Initial_state = {
    loading: false,
    error_message: null,
    isSuccess: false,
    response: [],
    set_payload: ""
}

const PrepareConsoleReducer = (state=Initial_state, action) => {
    switch(action.type){
        case PrepareConsoleTypes.PrepareConsole_ACTION_START:
            return {
                ...state,
                loading: true,
            }

        case PrepareConsoleTypes.PrepareConsole_FETCH_DATA: 
            return {
                ...state,
                loading: false,
                isSuccess: true,
                response: action.payload.data,
                set_payload: action.payload.set_payload
            }

        case PrepareConsoleTypes.PrepareConsole_FETCH_DATA_FAILED: 
            return {
                ...state,
                loading: false,
                isSuccess: false,
                error: action.payload
            }

        case PrepareConsoleTypes.PrepareConsole_SOCKET_UPDATE:
            const { data, set_payload } = action.payload;
            if(state.set_payload !== set_payload){
                return {
                    ...state
                }
            }
            return {
                ...state,
                response: data
            }
        default:
            return state;
    }
};

export default PrepareConsoleReducer;